import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowUpRight } from "lucide-react";
import { imgUrl, priceLabel } from "@/lib/api";

export const ServicePreview = ({ service, onClose, onBuy }) => {
  const [active, setActive] = useState(0);
  const imgs = Array.isArray(service?.gallery) ? service.gallery : [];
  return (
    <Dialog open={!!service} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-3xl overflow-y-auto border-[#163D43] bg-[#071D1F] text-teal-50" data-testid="service-preview-dialog">
        <DialogHeader>
          <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-teal-300">{service?.category} · prévias</p>
          <DialogTitle className="font-display text-2xl font-semibold">{service?.title}</DialogTitle>
          <DialogDescription className="text-teal-200">{service?.description}</DialogDescription>
        </DialogHeader>
        {imgs.length > 0 && (
          <div className="flex flex-col gap-3">
            <div className="flex h-[46vh] items-center justify-center overflow-hidden rounded-[3px] border border-[#163D43] bg-[#041214]">
              <img src={imgUrl(imgs[active] || imgs[0])} alt={`${service?.title} — prévia ${active + 1}`} className="h-full w-full object-contain" data-testid="service-preview-main" />
            </div>
            <div className="grid grid-cols-5 gap-2">
              {imgs.map((u, i) => (
                <button key={u + i} onClick={() => setActive(i)} data-testid={`service-preview-thumb-${i}`} className={`aspect-square overflow-hidden rounded-[3px] border transition-colors ${i === active ? "border-[#2DD4BF]" : "border-[#163D43] opacity-70 hover:opacity-100"}`}>
                  <img src={imgUrl(u)} alt="" className="h-full w-full object-cover" />
                </button>
              ))}
            </div>
          </div>
        )}
        <div className="flex items-center justify-between gap-4 pt-2">
          <span className="font-display text-xl">{priceLabel(service)}</span>
          <button onClick={() => { onClose(); onBuy(service); }} data-testid="service-preview-buy" className="inline-flex items-center gap-2 rounded-full bg-[#2DD4BF] px-6 py-3 font-semibold text-[#041214] transition-transform hover:-translate-y-0.5">
            Contratar <ArrowUpRight className="h-4 w-4" />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
